import _ from "lodash";
import axios from "axios";
import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import SideMenu from "./components/SideMenu";
import AppHeader from "./components/AppHeader";
import Footer from "./components/Footer";
import WidgetDrawer from "./components/Widget/WidgetDrawer";
import { getLocalMenus } from "./utils/Token";
import { PqCommunicationProvider } from "./store/pqCommunication-context";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import ErrorBoundary from "./pages/ErrorBoundary";

const SideMenusIcons = "./side-menu-icons.json";

export default function () {
  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const ToOpen = params.get("Type");
  const [data, setData] = useState([]);
  const sideMenuRef = useRef(null);
  const [sideMenuWidth, setSideMenuWidth] = useState(0);
  const [widgedVisible, setWidgedVisiblity] = useState(false);
  const [loader, setloader] = useState(false);
  const [clickfunction, setclickfunction] = useState(false);


 const [Trgger, setTrgger] = useState(false);
  const TrggerHandler = () => {
    setTrgger(!Trgger);
  };


  const handleWidgetDrawer = () => {
    setWidgedVisiblity(true);
    setclickfunction(true)
  };

  useEffect(() => {
    (async () => {
      const resp = await axios.get(SideMenusIcons);
      var info = getLocalMenus();
      const data = info.sort((r1, r2) => r1.displayOrder - r2.displayOrder);
      data.forEach((item) => {
        item.icon = resp?.data[item.actionName]; 
        item.isSelected = `/${item.actionName}` === location.pathname;
        if (_.isArray(item.sideMenus)) {
          item.sideMenus = item.sideMenus.sort(
            (r1, r2) => r1.displayOrder - r2.displayOrder
          );
        }
      });
      setData(data);
    })();
  }, []);

  useLayoutEffect(() => {
    setSideMenuWidth(sideMenuRef.current.offsetWidth);
  });


  useEffect(() => {
    if(ToOpen=="3"&&clickfunction!=true){
      setloader(true);
     setTimeout(() => {
      setWidgedVisiblity(true);
      setloader(false);
    }, 2000);
    }else if(ToOpen=="4"&&clickfunction!=true){
      setloader(true);
      setTimeout(() => {
       setWidgedVisiblity(true);
       setloader(false);
      }, 2000);
    }
    setclickfunction(false)
   }, [ToOpen]);

  return (
<>  <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
          >
            {/* <CircularProgress color="inherit" /> */}
          </Backdrop>
    <PqCommunicationProvider>
      <AppHeader handleWidgetDrawer={handleWidgetDrawer} Trgger={Trgger}/>
      <ErrorBoundary>
      <Grid container>
        <Grid item ref={sideMenuRef}>
          <SideMenu menuItems={data} />
        </Grid>
        <Grid
          className="main-content"
          item
          xs
          width={() => `calc(100% - ${sideMenuWidth}px)`}
        >
          
          <Box className="outlet-container">
            {widgedVisible && (
              <WidgetDrawer
              TrggerEvent={TrggerHandler}
                widgedVisible={widgedVisible}
                onChangeVisibility={(resp) => setWidgedVisiblity(resp)}
              />
            )}
            <Outlet />
          </Box>
     
          <Footer />
        </Grid>
      </Grid>
      </ErrorBoundary>
    </PqCommunicationProvider>
    </>
  );
}
